// Copyright 2024 - MinIO, Inc. All rights reserved.

import { Loader } from "mds";
import React from "react";

const RouteSuspense = () => {
  return (
    <div
      style={{
        display: "flex",
        height: "100%",
        width: "100%",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Loader />
    </div>
  );
};
export default RouteSuspense;
